import React from 'react'

import { ModalHeader, ModalTitle, ModalActions, CloseButton } from './styles'

const Component = ({
  title,
  slim,
  onClose: handleClose,
  children,
  className,
}) => (
  <ModalHeader slim={slim} className={className}>
    <ModalTitle data-testid="info_modalTitle">{title || children}</ModalTitle>
    <ModalActions>
      {handleClose && (
        <CloseButton data-testid="btn_closeModal" onClick={handleClose} />
      )}
    </ModalActions>
  </ModalHeader>
)

Component.displayName = 'ModalHeader'

export default Component
